module.exports = __webpack_public_path__ + "img/Grantis.0fe254ec.jpeg";